const fileDownloadUrl = ( path, isPublic = false ) => {
  const encodedPath = path.split( '/' ).join( '~' )
  return `${ process.env.REACT_APP_UPLOAD_HOST }/download/${ encodedPath }${ isPublic ? '?isPublic=true' : '' }`
}

export const fetchFileForView = async ( path, isPublic = false, downloadToken = null ) => {
  const response = await fetch( fileDownloadUrl( path, isPublic ), {
    headers: downloadToken ? { Authorization: `Bearer ${ downloadToken }` } : {}
  } )

  if ( !response.ok ) throw new Error( 'File download failed.' )

  return URL.createObjectURL( await response.blob() )
}

export const prefetchFileAndDownload = async ( path, name, isPublic = false, downloadToken = null ) => {
  const url = await fetchFileForView( path, isPublic, downloadToken )
  const link = document.createElement( 'a' )
  link.href = url
  link.download = name
  link.click()
  window.URL.revokeObjectURL( url )
}
